import React from 'react';
import { InternalLink } from 'components/InternalLink';
import { ExternalLink } from 'components/ExternalLink';
import { PrismicLinkTypes } from 'components/Slices/enums';
import { PrismicLinkFieldType, SliceContext } from 'components/Slices/types';

export interface PrismicLinkProps {
    label?: string | null;
    link: PrismicLinkFieldType;
    className?: string;
    children?: React.ReactNode;
    slice?: SliceContext;
}

export const PrismicLink = ({ label, link, className, children, slice }: PrismicLinkProps) =>
    link ? (
        link._linkType === PrismicLinkTypes.internal ? (
            <InternalLink label={label} link={link} className={className} children={children} slice={slice} />
        ) : (
            <ExternalLink label={label} link={link} className={className} children={children} slice={slice} />
        )
    ) : null;
